import React from 'react'
import styled from 'styled-components'
import { FormattedNumber } from 'react-intl'
import PropTypes from 'prop-types'
import { getCurrency } from 'core/utils/cultures/unit'
import { greys, font } from 'assets/themes/theme-default'

const PriceWrapper = styled.div`
  padding: 10px;
  text-align: center;
  background-color: ${props => props.theme.colors.color1.bg};
  color: ${greys.light4};
  font-size: ${font.size.lgxs};
  font-weight: ${font.weight.bold};
`
const PriceRender = props => {
  const { price } = props

  return (
    <PriceWrapper data-test="component-stock-vehicles-list-vehicleItem-PriceRender">
      {price &&
        `${(
          <FormattedNumber
            value={price}
            data-test="stock-vehicles-list-vehicleItem-PriceRender-FormattedNumber"
          />
        )} ${getCurrency()}`}
    </PriceWrapper>
  )
}

PriceRender.defaultProps = {
  price: null
}

PriceRender.propTypes = {
  price: PropTypes.number
}

export default PriceRender
